
import { defineComponent, onBeforeMount, reactive } from 'vue'

// components
import TheSelect from '@/common/components/UI/TheSelect/index.vue'
import TheButton from '@/common/components/UI/TheButton/index.vue'
import TheInput from '@/common/components/UI/TheInput/index.vue'

// classes
import { DataState } from '@/core/classes/DataState.class'

// types
import { Preference, Source, Theme } from '@/core/types/preferences.types'

//realisations
import { preferences } from '@/core/realisations/preferences.realisation'

// constants
import { CALLS_TYPE_OPTIONS } from '@/core/constants/calls.constants'

export default defineComponent({
    components: {
        TheButton,
        TheSelect,
        TheInput,
    },
    props: {
        loading: {
            type: Boolean,
            default: false,
        },
    },
    emits: ['reset', 'search'],
    setup(props, { emit }) {
        const filters_state = reactive({
            theme: null as number | null,
            email: null as string | null,
            name: null as string | null,
            source: null as number | null,
            createdAtFrom: null as string | null,
            createdAtTo: null as string | null,
        })

        const data_state = reactive({
            themes: new DataState<Theme>({}),
            sources: new DataState<Source>({}),
        })

        const reset = () => {
            if (props.loading) return

            filters_state.theme = null
            filters_state.email = null
            filters_state.name = null
            filters_state.source = null
            filters_state.createdAtFrom = null
            filters_state.createdAtTo = null

            emit('reset')
        }

        const search = () => {
            if (props.loading) return

            emit('search', { ...filters_state })
        }

        //

        const loadThemes = async () => {
            try {
                data_state.themes.is_loading = true

                const data = await preferences.getThemes()
                data_state.themes.list = data.data

                data_state.themes.is_failed = false
                data_state.themes.failure.error_state.is_cancel = false
            } catch (error) {
                data_state.themes.failure.catchError(error)

                if (!data_state.themes.failure.error_state.is_cancel) {
                    data_state.themes.is_failed = true
                }
            } finally {
                if (!data_state.themes.failure.error_state.is_cancel) {
                    data_state.themes.is_loading = false
                }
            }
        }

        const loadSources = async () => {
            try {
                data_state.sources.is_loading = true

                const data = await preferences.getSources()
                data_state.sources.list = data.data

                data_state.sources.is_failed = false
                data_state.sources.failure.error_state.is_cancel = false
            } catch (error) {
                data_state.sources.failure.catchError(error)

                if (!data_state.sources.failure.error_state.is_cancel) {
                    data_state.sources.is_failed = true
                }
            } finally {
                if (!data_state.sources.failure.error_state.is_cancel) {
                    data_state.sources.is_loading = false
                }
            }
        }

        onBeforeMount(() => {
            loadThemes()
            loadSources()
        })

        return {
            filters_state,
            data_state,
            reset,
            search,
            loadThemes,
            loadSources,
        }
    },
})
